class SettingsActionItem {
  public action?: Function;
  public content?: string;
  public label?: string;
  public prompt?: boolean;
  public title?: string;
}

export default SettingsActionItem;